<script>
export default {
    name: 'TocItem',
    props: ['item', 'level'],
    emits: ['scroll']
}
</script>

<template>
    <li class="toc-item">
        <span 
            class="toc-link" 
            :class="{ 'toc-link--nested': level > 0 }"
            @click="$emit('scroll', item.id)"
            :title="item.text"
        >
            {{ item.text }}
        </span>
        <ul v-if="item.children && item.children.length > 0" class="toc-list toc-list--nested">
            <toc-item 
                v-for="child in item.children" 
                :key="child.id" 
                :item="child"
                :level="level + 1"
                @scroll="$emit('scroll', $event)"
            />
        </ul>
    </li>
</template>

<style scoped>
.toc-item {
    margin-bottom: 4px;
}

.toc-link {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #374151;
    cursor: pointer;
    padding: 8px 12px;
    border-radius: 6px;
    transition: all 0.2s ease;
    line-height: 1.4;
    word-wrap: break-word;
    border-left: 3px solid transparent;
}

.toc-link:hover {
    background-color: #f3f4f6;
    color: #1f2937;
    border-left-color: #9ca3af;
}

.toc-link--nested {
    font-size: 13px;
    font-weight: 400;
    color: #6b7280;
    padding-left: 24px;
}

.toc-link--nested:hover {
    color: #1f2937;
    background-color: #f9fafb;
}

.toc-list--nested {
    margin-top: 4px;
    margin-left: 8px;
    border-left: 2px solid #e5e7eb;
    padding-left: 8px;
    list-style: none;
}
</style>
